import React, { useState,useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin, faFacebook, faInstagram  } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { db } from "../firebase-config";
import {collection,addDoc} from "firebase/firestore"
import Swal from 'sweetalert2';
import "../style/Contact.css";
import { useSelector } from "react-redux";
function Contact(){
const mode= useSelector(state=>state.Theme)
const[isDark,setMode]=useState();
useEffect(()=>{
    setMode(mode)
},[mode])
    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
        }
    });
    const[name,setName]=useState();
    const[message,setMessage]=useState();
    const addacount=async()=>{
            await addDoc(collection(db,"Visiteors"),{userName:name ,userMessage:message})
        }
    
    return(
    <div className={ `${isDark&&"dark"} `}>
        <div className={ ` max-[290px]:w-64 py-14  dark:bg-slate-800` }>
            <div className="container py-4 mx-auto w-full dark:bg-slate-700  bg-cyan-100">
                <div className="contc w-4/5 mx-auto dark:bg-slate-800 bg-blue-300 rounded-lg shadow-lg shadow-blue-700">
                    <h2 className="h2 ">
                        Contact Methods
                    </h2>
                    <div className="w-80 mx-auto">
                    <p className="prg"><span className="spco">Phone Numbers : </span> <span className="max-[430px]:block">+201149564002</span> <span>+201123737836</span></p>
                    <p className="prg"><span className="spco"><FontAwesomeIcon className="ico" icon={faEnvelope}/> </span>mahmudnagi192003@gmail.com</p>
                    <p className="prg"><span className="spco"><FontAwesomeIcon className="ico" icon={faFacebook} /> </span><a href="https://www.facebook.com/alzahrawi.mahmoud/about">Mahmud Alzhrawi</a></p>
                    <p className="prg"><span className="spco"><FontAwesomeIcon className="ico" icon={faLinkedin} /> </span><a href="https://www.linkedin.com/in/mahmud-al-zhrawy-995401263/">Mahmud_ALZhrawy</a></p>
                    <p className="prg"><span className="spco"><FontAwesomeIcon className="ico" icon={faInstagram} /> </span><a href="https://www.instagram.com/dev_alzhrawy/">dev_alzhrawy</a></p>
                    </div>
                </div>
                <div className="frm dark:bg-slate-800 w-4/5 mx-auto pb-4 bg-blue-300 rounded-lg shadow-lg shadow-blue-700">
                <h4 className=" border-b border-white  text-xl font-serif font-extrabold text-creamy text-center my-5">Your opinion matters to us! Don't hesitate to share your thoughts and feedback</h4>
                    <div className="mx-auto max-[340px]:w-64 w-80 shadow-md shadow-blue-400  ">
                        <form onSubmit={(event)=>{ event.preventDefault()
                        addacount();
                        Toast.fire({
                            icon: "success",
                            title: "Done"
                        });
                        setName('');
                        setMessage('');
                        }} >
                        <label className="mr-3 block text-creamy text-xl" >Your Name</label>
                        <input value={name} required className="mb-5 max-[430px]:w-3/5 w-full h-10 border-2 rounded-md   hover:border-blue-500"  type="text" onChange={(ev)=>{
                            setName(ev.target.value)
                        
                        }} />
                        <div className="pb-4">              
                        <textarea required  value={message} onChange={(ev)=>{
                            setMessage(ev.target.value)
                        
                        }} className="rounded-md text-center max-[430px]:w-3/5 "  cols={40} rows={10} placeholder="Tell us what's on your mind"></textarea>
                        </div>
                        <button className="btn -mt-1.5" type="submit" >Supmit</button>
                        </form>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
)
}
export default Contact;